import ui from "@/assets/scripts/ui";
import http from "@/services/config/http-common";

export default {
    //Algo fora do padrão, mas geral de acordo com este contexto

    methods: {

        objValid(obj) {
            return obj !== null && obj !== undefined && obj !== ''
        },

        infoDevelopment() {
            ui.msgError(this, 'Recurso em desenvolvimento!')
        },

        copyToClipboard(text,inputId) {
            if (!text) {
                console.warn("Nenhum conteúdo para copiar!");
                return;
            }

            navigator.clipboard.writeText(text).then(() => {
                ui.toast(this,'Texto copiado','Texto copiado com sucesso!')

                const input = document.getElementById(inputId);

                if (!input) {
                    console.warn("Elemento não encontrado!");
                    return;
                }

                // Seleciona todo o texto
                input.select();
                input.setSelectionRange(0, input.value.length); // Para compatibilidade com dispositivos móveis

                // Aguarda 1 segundo e então remove a seleção
                setTimeout(() => {
                    input.setSelectionRange(0, 0);
                    input.blur(); // Remove o foco do campo
                }, 1000);


            }).catch(err => {
                ui.msgError(this,'Falha ao tentar copiar texto: ' + err)
            });
        },

        isInsert() {
            return this.command === 'insert'
        },

        isUpdate() {
            return this.command === 'update'
        },

        isView() {
            return this.command === 'view'
        },

        isDelete() {
            return this.command === 'delete'
        },

        convertArrayIdsToObject(arrayIds, primaryKeyColumn) {

            let obj = []

            for (const item of arrayIds) {
                obj.push({[primaryKeyColumn]: item})
            }
            return obj

        },

        convertObjectToArrayIds(obj, primaryKeyColumn) {

            let arrayIds = []

            for (const item of obj) {
                arrayIds.push(item[[primaryKeyColumn]])
            }

            return arrayIds

        },

        getRenderRule(param) {

            if (this.userAuth.renderRules === undefined)
                console.log('Parametro não definido')

            if (param in this.userAuth.renderRules) {
                return this.userAuth.renderRules[param]
            } else {
                return false
            }

        },


        async downloadReport(reportId, primaryKey, name, ext = "pdf", title = "", params = "") {

            const nameFile = ui.nameFile(name, ext)

            await http.download("general/report/generate?type=R&platform=web&reportId=" + reportId + "&primaryKey=" + primaryKey + "&title=" + title + params, nameFile)
                .catch(error => ui.generalResponseError(this, error))

        },


        async downloadReportByTag(subValidationTag, primaryKey, name, ext = "pdf") {

            const nameFile = ui.nameFile(name, ext)

            await http.download("general/report/generate?type=R&platform=web&subValidationTag=" + subValidationTag + "&primaryKey=" + primaryKey, nameFile)
                .catch(error => ui.generalResponseError(this, error))

        },

        openModal(modal_id) {

            //Tempo necessário caso seja necessário montar objeto
            setTimeout(() => {
                document.activeElement.blur()
                this.$bvModal.show(modal_id)
            }, 200)


        },


        openDialogForm(modal_id, noOptionValue = '') {

            //Tempo necessário caso seja necessário montar objeto
            setTimeout(() => {
                document.activeElement.blur()

                if (noOptionValue !== '')
                    this.noOptionAdd = noOptionValue


                this.$bvModal.show(modal_id)
            }, 200)


        },

        routeExistsByName(name) {
            const defaultRoute = this.$router.options.routes.find(r => r.name === 'default');
            if (!defaultRoute || !defaultRoute.children) return false;

            return defaultRoute.children.some(child => child.name === name);
        },

        async goPath(path, addQuery = null, openNewTab = false) {
            await ui.goPath(this, path, addQuery, openNewTab)
        },

        async setRedirect(path, id, command, codError, addObjQuery, success) {

            let objQuery = {}

            //const lastPagePath = this.$store.getters.getLastPage.path
            let pathSend = path

            //if (pathSend === lastPagePath) {
            //Retorna com a listagem filtrada
            objQuery = this.$store.getters.getLastPage.query

            //}


            if (codError > 0) {
                objQuery.codError = codError
            } else {

                if (command === 'insert') {
                    if (success) {
                        objQuery.codSuccess = 1
                    } else {
                        objQuery.codError = 1
                    }
                } else if (command === 'update') {
                    if (success) {
                        objQuery.codSuccess = 2
                    } else {
                        objQuery.codError = 2
                    }
                } else if (command === 'delete') {
                    if (success) {
                        objQuery.codSuccess = 3
                    } else {
                        objQuery.codSuccess = 3
                    }
                }

            }


            if (pathSend.substring(0, 1) !== '/') {
                //Coloca a barra no início
                pathSend = "/" + pathSend
            }

            if (pathSend.substring(pathSend.length - 1) === '/') {
                //Retira a barra final
                pathSend = pathSend.substring(0, pathSend.length - 1)
            }


            //ATENÇÃO SE O PATH SEND NÃO BATER EXATAMENTE IGUAL AO PATH DO ROUTER DARÁ PROBLEMA
            await this.$router.push({path: pathSend, query: objQuery})


        },

        go(name) {
            this.$router.push({name: name})
        },

        relationAccessPageGeneral(name) {

            if (this.userAuth !== null && this.userAuth.relationPages !== undefined) {

                let e = this.userAuth.relationPages.find(el => el.name === name);

                if (e) {
                    return e.accessGeneral
                } else {
                    return false;
                }

            }


        },

        relationAccessSubValidation(subValidationTag) {

            if (this.userAuth && this.userAuth.subValidations) {
                let e = this.userAuth.subValidations.find(el => el.subValidationTag === subValidationTag);

                if (e) {
                    return true
                } else {
                    return false
                }
            }


        },

        relationAccessPageTitle(name) {

            let e = this.userAuth.relationPages.find(el => el.name === name);

            if (e) {
                return e.pageTitle;
            } else {
                return false;
            }

        },

        setIsLoadingPage(isLoadingPage) {
            this.$store.commit("setIsLoadingPage", isLoadingPage)
        },

        setBlackout(show) {
            this.$store.commit("setPageBlackoutShow", show)
        },

        setDisabledButtonSubmit(disabled) {
            this.$store.commit("setDisabledButtonSubmit", disabled)
        },


        resetFormDefault(form, notReset = []) {

            Object.keys(form).forEach(key => {

                if (key.toString() !== 'status' && (!notReset.find((str) => str === key))) {

                    if (form[key] && typeof form[key] === "string") {
                        form[key] = ""
                    } else if (form[key] && typeof form[key] === "number") {
                        form[key] = 0
                    } else if (form[key] && typeof form[key] === "boolean") {
                        form[key] = false
                    }

                }

            });

        },

        getPath() {

            let pathSend = this.path

            //Verifica se foi especificado algum path fora do padrão
            if (pathSend === '') {

                let path = this.$router.currentRoute.matched[1].path

                if (path) {

                    //Maior para o menor para evitar que os menores satisfação condinção incorretamente


                    if (path.substring(path.length - 9) === '/view/:id') {
                        pathSend = path.substring(1, path.length - 9)
                    } else if (path.substring(path.length - 11) === '/remove/:id') {
                        pathSend = path.substring(1, path.length - 11)
                    } else if (path.substring(path.length - 4) === '/new') {
                        pathSend = path.substring(1, path.length - 4)
                    } else if (path.substring(path.length - 4) === '/:id') {
                        pathSend = path.substring(1, path.length - 4)
                    } else {
                        pathSend = path
                    }

                } else {
                    pathSend = this.$router.currentRoute.path
                }

            }

            return pathSend

        }
    }
}